module.exports = __webpack_public_path__ + "static/media/17-iveco.5579dd4f.jpg";